<template>
  <v-card @click="props.onClick" :color="props.loading ? undefined : props.color">
    <v-card-title :style="{ padding: props.space, margin: props.space }">
      <v-skeleton-loader
        :loading="props.loading"
        type="list-item"
        width="100px"
        max-width="100%"
        style="margin: auto"
        v-if="props.loading === true"
      ></v-skeleton-loader>
      <span v-else>
        {{
          props.unit === "sec"
            ? formatSecond(props.count!).value
            : formatNumber(props?.count ?? 0, 1)
        }}
        {{ props.unit !== "sec" ? props.unit : "" }}
      </span>
    </v-card-title>
    <v-card-text :style="{ fontSize: props.bottomLabelSize ?? '1.25rem', textAlign: 'center' }">
      <span>
        {{ props.bottomLabel }}
      </span>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { formatNumber, formatSecond } from "@/utils";

const props = defineProps<{
  topLabel?: string;
  bottomLabel: string;
  count?: number;
  loading: boolean;
  onClick?: () => void;
  color?: string;
  topLabelSize?: string;
  bottomLabelSize?: string;
  space?: string;
  unit?: "sec" | "%" | "number";
}>();
</script>
